module.exports = __webpack_public_path__ + "assets/merriweather-bolditalic.37a4073b1d99c93ea7aeb03b37d078c0.woff2";